export const ENGLISH = 'english';
export const RUSSIAN = 'russian';
export const SPANISH = 'spanish';
export const CHINESE = 'chinese';

export const LANGUAGES = {
  english: 'en',
  russian: 'ru',
  spanish: 'es',
  chinese: 'zh',
};

export const APP_LANGUAGE_KEYS = [ENGLISH, RUSSIAN, SPANISH];
